import { PBRMaterial } from '@babylonjs/core'

import { State } from '@orangelv/bjs-renderer'

import assert from '../../../platform/assert'

const onAfterMaterialsUpdated = (webId?: string) => (state: State) => {
  const materialIdsForLeather = [
    'bigLacePinky_mat',
    'bigLace_mat',
    'binding_mat',
    'finger1_mat',
    'finger2_mat',
    'finger3_mat',
    'finger4_mat',
    'finger5_mat',
    'finger6_mat',
    'finger7_mat',
    'finger8_mat',
    'finger9_mat',
    'finger10_mat',
    'fingerLaces_mat',
    'heelLaces_mat',
    'iFingerPad_mat',
    'mFingerPad_mat',
    'iFingerHood_mat',
    'mFingerHood_mat',
    'lining_mat',
    'metallic_mat',
    'shellBack_mat',
    'trim_mat',
    'weltingBack_decoMesh_mat',
    'weltingBack_mat',
    'weltingBack_proMesh_mat',
    ...(webId ?
      [
        `${webId}_back_OvalR_mat`,
        `${webId}_back_mat`,
        `${webId}_base_mat`,
        `${webId}_fingerLaces_mat`,
        `${webId}_heelLaces_mat`,
        `${webId}_palm_mat`,
        `${webId}_trim_mat`,
        `${webId}_weltingPalm_mat`,
      ]
    : []),
  ]

  const materialIdsForSuede = [
    'fingerLacesInside_mat',
    'heelLacesInside_mat',
    'shellBackEdge_mat',
    'trimEdge_mat',
    ...(webId ?
      [
        `${webId}_backEdge_OvalR_mat`,
        `${webId}_backEdge_mat`,
        `${webId}_baseEdge_mat`,
        `${webId}_fingerLacesInside_mat`,
        `${webId}_heelLacesInside_mat`,
        `${webId}_palmEdge_mat`,
      ]
    : []),
  ]

  // TODO: Replace the list of material IDs with metadata tags from Blender.
  // It should be something like `'leatherMaterial' in material.metadata`.
  const isLeatherMaterial = (material: PBRMaterial) =>
    materialIdsForLeather.includes(material.id)
  const isSuedeMaterial = (material: PBRMaterial) =>
    materialIdsForSuede.includes(material.id)

  const { scene } = state

  assert(scene)

  for (const material of scene.materials as PBRMaterial[]) {
    const isLeather = isLeatherMaterial(material)
    const isSuede = isSuedeMaterial(material)

    if (!isLeather && !isSuede) {
      continue
    }

    material.roughness = isLeather ? 1.5 : 1

    const bumpTexture = material.bumpTexture

    if (bumpTexture) {
      bumpTexture.level = 3
    }

    if (isLeather && material.ambientTexture) {
      const ambientTexture = material.ambientTexture.clone()

      // Sheen.
      material.sheen.isEnabled = true
      material.sheen.intensity = 0.1
      material.sheen.roughness = 1
      material.sheen.texture = ambientTexture

      // Clear coat.
      material.clearCoat.isEnabled = true
      material.clearCoat.intensity = 0.025
      material.clearCoat.indexOfRefraction = 2
      material.clearCoat.roughness = 0.4

      // Lightmap.
      material.lightmapTexture = ambientTexture
      material.useLightmapAsShadowmap = true

      material.ambientTexture = null
    }

    if (isSuede && material.ambientTexture) {
      const ambientTexture = material.ambientTexture.clone()

      // Lightmap.
      material.lightmapTexture = ambientTexture
      material.useLightmapAsShadowmap = true

      material.ambientTexture = null
    }
  }
}

export default onAfterMaterialsUpdated
